var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _rect5, _rect6, _path6, _rect7, _rect8, _path7, _rect9, _rect10, _path8, _rect11, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.21875 34.1584C0.21875 33.6297 0.647312 33.2012 1.17597 33.2012H1.82409C2.35275 33.2012 2.78131 33.6297 2.78131 34.1584V34.2159H0.21875V34.1584Z",
    fill: "url(#paint0_linear_2_23994)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2832 0.240045C32.2832 0.768703 31.8546 1.19727 31.326 1.19727H30.6779C30.1492 1.19727 29.7206 0.768703 29.7206 0.240045V0.182541H32.2832V0.240045Z",
    fill: "url(#paint1_linear_2_23994)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7188 34.1584C29.7188 33.6297 30.1473 33.2012 30.676 33.2012H31.3241C31.8527 33.2012 32.2813 33.6297 32.2813 34.1584V34.2159H29.7188V34.1584Z",
    fill: "url(#paint2_linear_2_23994)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7832 0.240045C2.7832 0.768703 2.35464 1.19727 1.82598 1.19727H1.17786C0.649204 1.19727 0.220642 0.768703 0.220642 0.240045V0.182541H2.7832V0.240045Z",
    fill: "url(#paint3_linear_2_23994)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0791,
    y: 0.182617,
    width: 0.84375,
    height: 33.0181,
    fill: "url(#paint4_linear_2_23994)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5791,
    y: 0.182617,
    width: 0.84375,
    height: 33.0183,
    fill: "url(#paint5_linear_2_23994)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.9209,
    y: 16.9297,
    width: 28.6578,
    height: 0.708003,
    fill: "url(#paint6_linear_2_23994)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.9209,
    y: 31.125,
    width: 28.6578,
    height: 0.708003,
    fill: "url(#paint7_linear_2_23994)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9838 4.27246H4.05957V15.167H14.9838V4.27246ZM7.23364 6.68709V12.3084H8.46954V10.1316H9.07553C9.235 10.1316 9.37321 10.1609 9.49015 10.2194C9.6071 10.2725 9.70544 10.3709 9.78517 10.5144L10.7579 12.3084H12.1214L11.2124 10.642C11.0317 10.3177 10.8005 10.113 10.5187 10.028C10.9174 9.92699 11.2231 9.73829 11.4357 9.46187C11.6536 9.18014 11.7626 8.8293 11.7626 8.40937C11.7626 7.86717 11.5925 7.44457 11.2523 7.14158C10.9121 6.83858 10.4284 6.68709 9.80112 6.68709H7.23364ZM9.57786 9.23861H8.46954V7.65188H9.57786C10.2423 7.65188 10.5745 7.91501 10.5745 8.44126C10.5745 8.97283 10.2423 9.23861 9.57786 9.23861Z",
    fill: "url(#paint8_linear_2_23994)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.01562,
    y: 15.2451,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint9_linear_2_23994)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1406,
    y: 15.2451,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint10_linear_2_23994)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.468 18.4688H17.5156V29.3633H28.468V18.4688ZM21.4927 26.425C21.8861 26.5366 22.3034 26.5924 22.7446 26.5924C23.2123 26.5924 23.6163 26.5207 23.9565 26.3771C24.3021 26.2283 24.5678 26.0236 24.7539 25.7632C24.9453 25.4974 25.0409 25.1891 25.0409 24.8382C25.0409 24.0515 24.5253 23.5465 23.4941 23.3233L22.5931 23.1319C22.3167 23.0734 22.1226 22.9964 22.011 22.9007C21.8994 22.805 21.8436 22.6801 21.8436 22.5259C21.8436 22.3186 21.9339 22.1512 22.1147 22.0236C22.3007 21.8907 22.5612 21.8242 22.8961 21.8242C23.518 21.8242 24.0469 21.997 24.4828 22.3425L24.8416 21.4335C24.6183 21.2316 24.3366 21.0747 23.9964 20.9631C23.6562 20.8515 23.2921 20.7957 22.904 20.7957C22.4522 20.7957 22.0535 20.8701 21.708 21.0189C21.3678 21.1678 21.102 21.3777 20.9107 21.6488C20.7193 21.9146 20.6236 22.2256 20.6236 22.5817C20.6236 23.411 21.1259 23.9319 22.1306 24.1445L23.0316 24.3359C23.324 24.3997 23.5286 24.4768 23.6456 24.5671C23.7625 24.6575 23.821 24.7798 23.821 24.9339C23.821 25.1147 23.7359 25.2662 23.5658 25.3884C23.4011 25.5054 23.1273 25.5638 22.7446 25.5638C22.3937 25.5638 22.0562 25.5133 21.7319 25.4123C21.413 25.3113 21.1286 25.1731 20.8788 24.9977L20.52 25.9705C20.7804 26.1618 21.1047 26.3133 21.4927 26.425Z",
    fill: "url(#paint11_linear_2_23994)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5156,
    y: 29.4414,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint12_linear_2_23994)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6406,
    y: 29.4414,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint13_linear_2_23994)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4844 4.31738H17.5156V15.1749H28.4844V4.31738ZM22.5554 6.66019L19.9719 12.2815H21.2238L21.7421 11.0616H24.3653L24.8916 12.2815H26.1355L23.552 6.66019H22.5554ZM22.1567 10.0968L23.0417 7.97582H23.0577L23.9587 10.0968H22.1567Z",
    fill: "url(#paint14_linear_2_23994)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5156,
    y: 15.249,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint15_linear_2_23994)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6406,
    y: 15.249,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint16_linear_2_23994)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9766 18.5146H4.00781V29.3722H14.9766V18.5146ZM7.07559 20.8574V26.4787H8.19188V23.074L9.63509 25.6335H10.3288L11.78 23.0501V26.4787H12.9042V20.8574H11.8916L10.0019 24.3099L8.10417 20.8574H7.07559Z",
    fill: "url(#paint17_linear_2_23994)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4.01465,
    y: 29.4443,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint18_linear_2_23994)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1348,
    y: 29.4443,
    width: 0.84375,
    height: 0.84375,
    fill: "url(#paint19_linear_2_23994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_23994",
    x1: 0.668508,
    y1: 33.1928,
    x2: 1.08337,
    y2: 34.7637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_23994",
    x1: 31.8334,
    y1: 1.20559,
    x2: 31.4186,
    y2: -0.365303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_23994",
    x1: 30.1685,
    y1: 33.1928,
    x2: 30.5834,
    y2: 34.7637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_23994",
    x1: 2.33344,
    y1: 1.20559,
    x2: 1.91858,
    y2: -0.365303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_23994",
    x1: 1.22719,
    y1: -0.0883841,
    x2: 3.31924,
    y2: -0.00822569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_23994",
    x1: 30.7272,
    y1: -0.0883858,
    x2: 32.8192,
    y2: -0.00822788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_23994",
    x1: 6.95067,
    y1: 16.9239,
    x2: 6.96999,
    y2: 18.0961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_23994",
    x1: 6.95067,
    y1: 31.1192,
    x2: 6.96999,
    y2: 32.2914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_23994",
    x1: 5.9769,
    y1: 4.18304,
    x2: 14.2966,
    y2: 16.6916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_23994",
    x1: 4.16371,
    y1: 15.2382,
    x2: 4.80873,
    y2: 16.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_23994",
    x1: 14.2887,
    y1: 15.2382,
    x2: 14.9337,
    y2: 16.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_23994",
    x1: 19.4379,
    y1: 18.3793,
    x2: 27.7493,
    y2: 30.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_23994",
    x1: 17.6637,
    y1: 29.4345,
    x2: 18.3087,
    y2: 30.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_23994",
    x1: 27.7887,
    y1: 29.4345,
    x2: 28.4337,
    y2: 30.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_23994",
    x1: 19.4408,
    y1: 4.22827,
    x2: 27.7081,
    y2: 16.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_23994",
    x1: 17.6637,
    y1: 15.2421,
    x2: 18.3087,
    y2: 16.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_23994",
    x1: 27.7887,
    y1: 15.2421,
    x2: 28.4337,
    y2: 16.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_23994",
    x1: 5.93296,
    y1: 18.4255,
    x2: 14.2003,
    y2: 30.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_23994",
    x1: 4.16274,
    y1: 29.4374,
    x2: 4.80775,
    y2: 30.4045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_23994",
    x1: 14.2829,
    y1: 29.4374,
    x2: 14.9279,
    y2: 30.4045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4947ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D9F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small_logo.3151da39df839b9a487c717fc5b6d602.svg";
export { ForwardRef as ReactComponent };